import React from "react";
import "../PdfViewer.css";

const PdfViewer = () => {
  const pdfFiles = [
    {
      id: 1,
      title: "Polynomials",
      desc: "Practice problems and solutions for polynomials.",
      url: "https://flippedlearning.neinus.com/pdf/Polynomials.pdf",
    },
    {
      id: 2,
      title: "Remainder Theorem",
      desc: "Learn how to apply the remainder theorem in polynomials.",
      url: "https://flippedlearning.neinus.com/pdf/Remainder-Theorem.pdf",
    },
    {
      id: 3,
      title: "Algebraic Identities",
      desc: "A complete guide for understanding algebraic identities.",
      url: "https://flippedlearning.neinus.com/pdf/Algebraic-Identities.pdf",
    },
    {
      id: 4,
      title: "Factorisation",
      desc: "Techniques for breaking expressions into simpler factors.",
      url: "https://flippedlearning.neinus.com/pdf/Factorisation-Breaking-Expressions-into-Simpler-Parts.pdf",
    },
    {
      id: 5,
      title: "Division of Polynomials",
      desc: "Step-by-step methods for dividing polynomials.",
      url: "https://flippedlearning.neinus.com/pdf/Division-of-Polynomials.pdf",
    },
    {
      id: 6,
      title: "Greatest Common Divisor (GCD)",
      desc: "Finding the GCD of numbers and expressions.",
      url: "https://flippedlearning.neinus.com/pdf/Greatest-Common-Divisor-GCD.pdf",
    },
    {
      id: 7,
      title: "Linear Equations in Two Variables",
      desc: "Solve linear equations with two unknowns.",
      url: "https://flippedlearning.neinus.com/pdf/Greatest-Common-Divisor-GCD.pdf",
    },
  ];

  return (
    <section className="pdf-section">
      <h3>Learning Materials</h3>
      <div className="pdf-grid">
        {pdfFiles.map((pdf) => (
          <div key={pdf.id} className="pdf-card">
            <div className="pdf-info">
              <h3>{pdf.title}</h3>
              <p>{pdf.desc}</p>
            </div>
            <div className="pdf-actions">
              <button
                onClick={() => window.open(pdf.url, "_blank")}
                className="view-btn"
              >
                View
              </button>
              <a href={pdf.url} download className="download-btn">
                Download
              </a>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default PdfViewer;
